import { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";
import { t } from "i18next";
import ApiUrls from "../../helpers/urls/ApiUrls";
import api from "../../helpers/api/Api";
import SelectCustom from "../SelectCustom";

function SelectDomainOwner({ value, onChange, error }) {
  const [owners, setOwners] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);

  useEffect(() => {
    getUsersList();
  }, []);

  const getUsersList = () => {
    api.post(ApiUrls.user.list, {})
      .then((response) => {
        setOwnerList(response.data.data);
      })
      .catch((error) => {
        setUsersLoading(false);
      });
  }

  const setOwnerList = (data) => {
    const ownerList = [];
    data.map((d) => {
      if (d.parentid === 0 && d.type === "1") {
        ownerList.push(d);
      }
    });

    setOwners(ownerList);
    setUsersLoading(false);
  }

  return (
     <SelectCustom
        id="domain-owner-select"
        value={value}
        error={error}
        label={t("domain.owner")}
        onChange={onChange}
        loading={usersLoading}
     >
       <MenuItem value={"all"} key="all">{t("global.all")}</MenuItem>
       <MenuItem value={1} key="admin">admin</MenuItem>
       {owners.map((owner, i) => {
         return (
            <MenuItem value={owner.id} key={i}>
              {owner.user}
            </MenuItem>
         )
       })}
     </SelectCustom>
  );
}

export default SelectDomainOwner;
